export default __webpack_public_path__ + "085869bc47c9ad5b6d91bd8bc79441e4.png";